import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/back.png';
import _imports_1 from '../assets/images/posterSearch-des6.png';
import _imports_2 from '../assets/images/posterSearch-des7.png';
import _imports_3 from '../assets/images/posterSearch-des8.png';
import _imports_4 from '../assets/images/posterSearch-des9.png';
import _imports_5 from '../assets/images/posterSearch-des10.png';
import _imports_6 from '../assets/images/posterSearch-des1.png';
import _imports_7 from '../assets/images/posterSearch-des2.png';
import _imports_8 from '../assets/images/posterSearch-des3.png';
import _imports_9 from '../assets/images/posterSearch-des4.png';
import _imports_10 from '../assets/images/posterSearch-des5.png';
const _withScopeId = n => (_pushScopeId("data-v-e80c0cdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-content"
};
const _hoisted_2 = {
  class: "go-back"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "conditioner"
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "content-font"
};
const _hoisted_7 = {
  class: "content-title"
};
const _hoisted_8 = {
  class: "content-font"
};
const _hoisted_9 = {
  class: "content-title"
};
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"poster\" data-v-e80c0cdc><img src=\"" + _imports_1 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_2 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_3 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_4 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_5 + "\" alt=\"\" data-v-e80c0cdc></div>", 1);
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "explain"
};
const _hoisted_13 = {
  href: "/creposterImages.zip",
  download: ""
};
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"example\" data-v-e80c0cdc><img src=\"" + _imports_6 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_7 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_8 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_9 + "\" alt=\"\" data-v-e80c0cdc><img src=\"" + _imports_10 + "\" alt=\"\" data-v-e80c0cdc></div>", 1);
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "copyright"
};
import i18n from '@/language/index';
export default {
  __name: 'PosterSearchDescription',
  emits: ['goBack'],
  setup(__props, {
    emit: emits
  }) {
    const goBack = () => {
      emits('goBack');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('poster.titleDescription')), 1), _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: goBack
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('protection.format')), 1), _createTextVNode(_toDisplayString(_ctx.$t('poster.formatDescription')), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('protection.context')), 1), _createTextVNode(_toDisplayString(_ctx.$t('poster.contextDescription')), 1)])]), _hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('protection.try')), 1), _createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(_ctx.$t('poster.pack')), 1), _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('protection.zip')), 1)]), _hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('protection.copyright')), 1), _createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(_ctx.$t('protection.explainImage')), 1), _createElementVNode("span", {
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'linkPadding' : '')
      }, _toDisplayString(_ctx.$t('protection.research')), 3), _createTextVNode(" " + _toDisplayString(_ctx.$t('protection.explainImageSeparate')), 1)])])]);
    };
  }
};